import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { CancelTemplateProps } from '../../../../templates/Cancel'
import { useDefaultLayoutProps } from '../../../../layouts/DefaultLayout/useProps'
import { actions } from '../../../../redux'

export const useCancelSlotProps = (): CancelTemplateProps => {
  const layout = useDefaultLayoutProps()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return useMemo(
    () => ({
      layout,
      titleDescription: {
        title: t('cancelSlot.title'),
      },
      actions: {
        accept: {
          text: t('cancelSlot.actions.accept.text'),
          onClick: () => {
            dispatch(actions.app.deleteRegistrationRequest(null))
          },
        },
        cancel: {
          text: t('cancelSlot.actions.cancel.text'),
          link: {
            href: t('cancelSlot.actions.cancel.url'),
          },
        },
      },
    }),
    [layout, dispatch, t]
  )
}
